module.exports = "/images/ok.svg?1ddb37ab28a965a70133a1a9f37b2633";